<div mat-dialog-content *ngIf="!loading_icon">
    <app-form-api-validation-errors
      *ngIf="error"
      [errors]="error"
    ></app-form-api-validation-errors>
    <form [formGroup]="entityFormGroup" fxLayout="column">
      <!-- Serial number form field -->
      <mat-form-field appearance="fill">
        <mat-label>{{
          "taggable-resource-route.dialog.field.description" | translate
        }}</mat-label>
        <input matInput formControlName="description" />
        <mat-error
          *ngIf="entityFormGroup.get('description')?.hasError('required')"
          >{{ "common.dialog.errors.required" | translate }}</mat-error
        >
        <mat-error
          *ngIf="entityFormGroup.get('description')?.hasError('maxlength')"
        >
          {{ "common.dialog.errors.maxLength" | translate }}
        </mat-error>
      </mat-form-field>
      <!-- IDCLI form field
      <mat-form-field appearance="fill">
        <mat-label>{{
          "taggable-resource-route.dialog.field.idcli" | translate
        }}</mat-label>
        <input matInput formControlName="idcli" />
        <mat-error *ngIf="entityFormGroup.get('idcli')?.hasError('required')">{{
            "common.dialog.errors.required" | translate
        }}</mat-error>
      </mat-form-field>-->
      <!-- Ods id form field-->
      <div  style="display: flex; align-items: center; width: 100%; vertical-align: middle;">
        <mat-form-field appearance="fill" style="width: 90%;">
          <mat-label>{{ "taggable-resource-route.dialog.field.idcli"  | translate }}</mat-label>
          <input matInput formControlName="idcli" [readonly]="!readonly" />
          <mat-error *ngIf="entityFormGroup.get('idcli')?.hasError('required')">{{
            "common.dialog.errors.required" | translate
            }}</mat-error>
          <mat-error *ngIf="entityFormGroup.get('idcli')?.hasError('maxlength')">
            {{ "common.dialog.errors.maxLength" | translate }}
          </mat-error>
        </mat-form-field>
        <mat-checkbox [checked]="readonly" (change)="setInput()" style="margin-right: 20px;" color="primary"></mat-checkbox>
      </div>
      <!-- Types form field -->
      <mat-form-field appearance="fill" *ngIf="waste_types">
        <mat-label>{{ "taggable-resource-route.dialog.field.type" | translate }}</mat-label>
        <input
          matInput
          formControlName="type"
          [matAutocomplete]="groupAutocomplete"
        />
        <mat-chip-listbox #chipList>
          <mat-chip *ngFor="let option of this.selectedOptions" [removable]="true" (removed)="removeOption(option)">
            {{ option.type }} {{ option.waste_type }} {{ option.capacity }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        </mat-chip-listbox>
        <mat-autocomplete
            #groupAutocomplete="matAutocomplete"
            [displayWith]="displayTypeFn()"
            (optionSelected)="addOption($event.option.value)"
        >
            <mat-option
            *ngFor="let option of availableWasteTypes"
            [value]="option"
            >
            {{ option.type }} {{ option.waste_type }} {{ option.capacity }}
            </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="entityFormGroup.get('type')?.hasError('required')">{{
            "common.dialog.errors.required" | translate
        }}</mat-error>
      </mat-form-field> 
      <!-- List form field -->
      <mat-form-field appearance="fill" *ngIf="groups">
        <mat-label>{{ "taggable-resource-route.dialog.field.list" | translate }}</mat-label>
        <input
          matInput
          formControlName="list"
          [matAutocomplete]="listAutocomplete"
        />
        <mat-autocomplete
          #listAutocomplete="matAutocomplete"
          [displayWith]="displayListFn"
        >
          <mat-option
            *ngFor="let option of filteredLists | async"
            [value]="option.id"
          >
            {{ option.name }}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="entityFormGroup.get('group')?.hasError('required')">{{
          "common.dialog.errors.required" | translate
        }}</mat-error>
        <mat-error *ngIf="entityFormGroup.get('group')?.hasError('pattern')">{{
          "common.dialog.errors.autocomplete_option" | translate
        }}</mat-error>
      </mat-form-field>
      <!-- Group form field -->
      <mat-form-field appearance="fill" *ngIf="groups">
        <mat-label>{{ "taggable-resource-route.dialog.field.group" | translate }}</mat-label>
        <input
          matInput
          formControlName="group"
          [matAutocomplete]="groupAutocomplete"
        />
        <mat-autocomplete
          #groupAutocomplete="matAutocomplete"
          [displayWith]="displayFn"
        >
          <mat-option
            *ngFor="let option of filteredGroups | async"
            [value]="option.id"
          >
            {{ option.name }}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="entityFormGroup.get('group')?.hasError('required')">{{
          "common.dialog.errors.required" | translate
        }}</mat-error>
        <mat-error *ngIf="entityFormGroup.get('group')?.hasError('pattern')">{{
          "common.dialog.errors.autocomplete_option" | translate
        }}</mat-error>
      </mat-form-field>
      <!-- Map form field-->
      <mat-card class="mini-map">
        <mat-card-content
          id="mapM2"
          leaflet
          [leafletOptions]="options"
          (leafletMapReady)="onMapReady($event)"
          (leafletMapZoomEnd)="onMapZoomEnd($event)"></mat-card-content>
      </mat-card>
      
      <!-- Error for start_point -->
      <div *ngIf="entityFormGroup.get('start_point')?.hasError('required') && (entityFormGroup.get('start_point')?.touched || entityFormGroup.get('start_point')?.dirty)"
        style="color: red;">
        Errore: il campo punto di inizio è obbligatorio.
      </div>
      <!-- Error for finish_point -->
      <div *ngIf="entityFormGroup.get('finish_point')?.hasError('required') && (entityFormGroup.get('finish_point')?.touched || entityFormGroup.get('finish_point')?.dirty)"
        style="color: red;">
        Errore: il campo punto di fine è obbligatorio.
      </div>
    </form>
  </div>
  <div mat-dialog-actions fxLayoutAlign="center center">
    <button mat-button mat-dialog-close (click)="clear()" *ngIf="!loading_icon">
      {{ "common.dialog.cancel" | translate }}
    </button>
    <mat-spinner *ngIf="input_loading===true" class="spinner internal-spinner" diameter="20"></mat-spinner>
    <button *ngIf="input_loading===false && !loading_icon" mat-button cdkFocusInitial color="primary" (click)="saveClicked()" [disabled]="disableButton()">
      {{ "common.dialog.save" | translate }}
    </button>
  </div>

  <div  *ngIf="loading_icon">
    <h3>Attendere... Caricamento in corso...</h3>
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  
  <ng-template #loading>
    <!-- While waiting for the options to load show a single, disabled option with a loading spinner [disabled]="disableButton()" -->
    <mat-option>
      <div class="deferred-select-placeholder-container">
        <span>Loading...</span>
        <mat-spinner class="spinner internal-spinner" diameter="20"></mat-spinner>
      </div>
    </mat-option>
  </ng-template>